import { render, staticRenderFns } from "./MaterialList.vue?vue&type=template&id=6cf19d3c&scoped=true&"
import script from "./MaterialList.vue?vue&type=script&lang=ts&"
export * from "./MaterialList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf19d3c",
  null
  
)

export default component.exports